import { fromNumberString } from '@migrate/utils/number'

export default function renderPercentage(value?: string | number, fractionDigits?: number): string {
  if (value !== undefined && value !== null && value !== '') {
    if (!isNaN(Number(value))) {
      const percent: string = typeof value === 'string' ? value : value.toString()
      return fromNumberString(percent)
        .toNumberConverter()
        .toLocalizedPercentString({
          minimumFractionDigits: fractionDigits !== undefined ? fractionDigits : 2,
          maximumFractionDigits: fractionDigits !== undefined ? fractionDigits : 2,
        })
    }
  }
  return value ? value.toString() : ''
}
